import React, { useState } from 'react';
import AppLayout from '../components/AppLayout';
import { Alert, Box, Button, Paper, TextField, Typography } from '@mui/material';
import api from '../api/client';

export default function Ocorrencia() {
  const [form, setForm] = useState({ nome: '', email: '', assunto: '', mensagem: '' });
  const [ok, setOk] = useState(false);
  const [error, setError] = useState(null);

  const setField = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setError(null); setOk(false);
    try {
      await api.post('/api/api/ocorrencias/email', form);
      setOk(true);
      setForm({ nome: '', email: '', assunto: '', mensagem: '' });
    } catch (err) {
      const msg = err?.response?.data?.message || 'Erro ao enviar ocorrência';
      setError(msg);
    }
  };

  return (
    <AppLayout>
      <Typography variant="h5" fontWeight={700} gutterBottom>Ocorrência</Typography>
      {ok && <Alert severity="success" sx={{ mb: 2 }}>Enviado com sucesso!</Alert>}
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <Paper sx={{ p: 3 }} component="form" onSubmit={submit}>
        <TextField label="Nome" fullWidth required sx={{ mb: 2 }} value={form.nome} onChange={e=>setField('nome', e.target.value)} />
        <TextField label="Email" type="email" fullWidth required sx={{ mb: 2 }} value={form.email} onChange={e=>setField('email', e.target.value)} />
        <TextField label="Assunto" fullWidth required sx={{ mb: 2 }} value={form.assunto} onChange={e=>setField('assunto', e.target.value)} />
        <TextField label="Mensagem" fullWidth required multiline minRows={4} value={form.mensagem} onChange={e=>setField('mensagem', e.target.value)} />
        <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
          <Button type="submit" variant="contained">Enviar</Button>
          <Button type="button" variant="outlined" onClick={()=>setForm({ nome:'', email:'', assunto:'', mensagem:'' })}>Limpar</Button>
        </Box>
      </Paper>
    </AppLayout>
  );
}
